var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("FinanceManage.GpExplain"),
        width: "450px",
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-position": "left", "label-width": "75px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("FinanceManage.GpExplain") } },
            [
              _c("cargo-advance-select", {
                attrs: {
                  no: "GpExplainTitle",
                  "select-type": _vm.selectTypeNames.basic_data_GpExplainTitle,
                  filterable: "",
                  clearable: false,
                  "default-value": _vm.form.code
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.form.code = p.value
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 7 },
                model: {
                  value: _vm.form.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "ok" },
              on: { click: _vm.btnConfirm }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }